import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import { useRootSelector } from '../../../../store/hooks';
import { selectSiteArticlesData } from '../../../../store/features/siteArticles';
import { selectSiteHeader } from '../../../../store/features/siteHeader';

import Heading from '../../../sections/ArticlesTable/Heading';
import FeaturedArticlesList from '../../../sections/ArticlesTable/FeaturedArticlesList';
import ArticlesList from '../../../sections/ArticlesTable/ArticlesList';

import styles from './ArticlesView.module.scss';

export default function ArticlesView() {
  const {
    meta: { title: siteTitle, description: siteDescription },
  } = useRootSelector(selectSiteHeader);
  const {
    details: { pageTitle, showPageHeader, titleSize, title, metaDescription },
  } = useRootSelector(selectSiteArticlesData);

  const helmet = {
    title: title || `News & Insights: ${siteTitle}`,
    description: metaDescription || siteDescription,
  };

  return (
    // @ts-ignore
    <SiteLayout helmet={helmet}>
      <div className={styles.wrapper}>
        {showPageHeader && (
          <div className="container">
            <Heading headingSize={titleSize}>{pageTitle}</Heading>
          </div>
        )}
        <FeaturedArticlesList />
        <ArticlesList />
      </div>
    </SiteLayout>
  );
}
